import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Project } from '../Project';
import { Settings } from '@common/core/config/settings.service';
import { DnsPopupService } from './dns-popup.service';

@Component({
  selector: 'dns-popup',
  templateUrl: './dns-popup.component.html',
  styleUrls: ['./dns-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DnsPopupComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DnsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {project: Project},
    public settings: Settings,
    public dnsPopupService: DnsPopupService
    )
   { }

  ngOnInit(): void {
    this.dnsPopupService.init(this.data.project,  this.dialogRef);
    console.log('project', this.dnsPopupService.project);
    
  }
  close(){
    this.dialogRef.close();
  }

}
